import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "middle_title" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "button-row" }

import { useUserStore } from '@/stores/user'
import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'logoutPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const userStore = useUserStore()
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}
const logOut = () => {
    userStore.signOut()
    sessionStorage.setItem('openPromotionPopup', '');
}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "center",
    style: {
        width: '90%',
        borderRadius: '15px',
        background: '#024a49',
        zIndex: '10001',
        padding: '20px'
    }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_row, {
        gutter: 10,
        class: "container"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('profile.toLogout')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('profile.sureToLogout')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_col, {
              span: 12,
              class: "cancel_btn",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: 12,
              class: "loagout_btn",
              onClick: logOut
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.toLogout')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})